import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPageName } from "../../Redux/Actions/webAppActions.js";

const Confirmation = () => {
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.login);

  React.useEffect(() => {
    dispatch(setPageName("Confirmation"));
    window.sessionStorage.setItem("Confirmation",true)
  }, []);

  if (theme) {
    const Confirmation1 = React.lazy(() => import(`./${theme}/Confirmation`));
    return <Confirmation1 />;
  } else {
    return null;
  }
};
export default Confirmation;
